// Single source for header and footer links

export const servicePages = [
  { to: '/services/web-development', label: 'Web development' },
  { to: '/services/mobile-apps', label: 'Mobile apps' },
  { to: '/services/web-design', label: 'Web design' },
  { to: '/services/ecommerce', label: 'E-commerce' },
  { to: '/services/consulting', label: 'Consulting & modernization' },
  { to: '/services/seo', label: 'SEO' },
  { to: '/services/small-business', label: 'Small business' },
  { to: '/services/social-media', label: 'Social media' },
];

export const primaryNav = [
  { to: '/work', label: 'Work' },
  { to: '/#detroit', label: 'Detroit' },
  { to: '/#community', label: 'Community' },
  { to: '/contact', label: 'Contact' },
];
